/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withTranslation } from 'react-i18next';

import Alert from '../../Common/AlertContainer';
import Error from '../../Common/Error';
import { formValidator } from '../../../AppUtil/AppUtil';
import { commonStyle } from '../../Common/CommonStyle';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

class index extends Component { // NOSONAR
    constructor(props) {
        super(props);
        this.state = {
            _topHeading: '',
            _resetPasswordForm: {
                otp: {
                    value: '',
                    placeholder: 'label.confirmation_code',
                    isValid: false,
                    isTouched: false,
                    validationRules: {
                        isRequired: {
                            value: true,
                            errorMsg: 'error_message.confirmation_code'
                        }
                    },
                    error_text: ''

                },
                password: {
                    value: '',
                    placeholder: 'label.create_new_password',
                    isValid: false,
                    isTouched: false,
                    validationRules: {
                        isRequired: {
                            value: true,
                            errorMsg: 'error_message.required_password'
                        },
                        pattern: {
                            value: PATTERN.PASSWORD,
                            errorMsg: 'error_message.password_pattern'
                        }
                    },
                    error_text: ''
                },
                confirm_password: {
                    value: '',
                    placeholder: 'label.confirm_password',
                    isValid: false,
                    isTouched: false,
                    validationRules: {
                        isRequired: {
                            value: true,
                            errorMsg: 'error_message.required_confirm_password'
                        }
                    },
                    error_text: ''
                }
            }
        };
    }

    /**
     * This function handle all input change event inside login form
     * @returns {void}
     */
    handelInputChange = (e) => {
        this.props.resetAuthError();
        const name = e.target.name;
        const value = e.target.value;
        const forgotPasswordForm = {
            ...this.state._resetPasswordForm
        };
        const updatedFormElement = {
            ...forgotPasswordForm[name]
        };
        updatedFormElement.value = value;
        updatedFormElement.isValid = true;
        updatedFormElement.error_text = '';
        forgotPasswordForm[name] = updatedFormElement;
        this.setState({
            _resetPasswordForm: forgotPasswordForm
        });

    }

    /**
     * This function handle submit login form
     * @returns {Promise<void>}
     */
    onSubmitHandler = async (e) => {
        e.preventDefault();
        if (!this.formValidator()) {
            return false;
        }
        const requestBody = {
            otp: this.state._resetPasswordForm.otp.value,
            password: this.state._resetPasswordForm.password.value
        };
        await this.props.onReset(requestBody);
    }

    /**
     * This function validate all field in login form
     */
    formValidator = () => {
        const form = {
            ...this.state._resetPasswordForm
        };
        let isConfirmPassFieldValid = true;
        const [updatedForm, isFormValid] = formValidator(form);
        if (updatedForm.confirm_password.isValid &&
            updatedForm.confirm_password.isTouched &&
            updatedForm.confirm_password.value !== updatedForm.password.value) {
            updatedForm.confirm_password.isValid = false;
            updatedForm.confirm_password.error_text = 'error_message.confirmPasswordMissMatch'; // NOSONAR
            isConfirmPassFieldValid = false;
        }
        this.setState({
            _resetPasswordForm: updatedForm
        });
        return isFormValid && isConfirmPassFieldValid;

    }

    setTopHeading = () => {
        this.setState({
            _topHeading: 'signin.text_for_reset_password'
        });
    }

    componentDidMount () {
        this.setTopHeading();
    }

    render() {
        const { classes } = this.props;
        const { t } = this.props;
        return (
            <Container
                component="main"
                maxWidth="md"
            >
                <CssBaseline />
                <Paper
                    className={classes.paper}
                    id='paperform'
                >
                    <Grid
                        id='full-wdith'
                        item
                        md
                        zeroMinWidth
                    >
                        <div>
                            <div
                                className={classes.paper}
                                id='paperform'
                            >
                                <Avatar className={classes.avatar}>
                                    <LockOutlinedIcon />
                                </Avatar>
                                <Typography
                                    component="h1"
                                    variant="h5"
                                >
                                    {t('label.reset_password')}
                                </Typography>
                                <Typography
                                    className="text-center light-gray"
                                    style={{ width: '80%' }}
                                >
                                    {t(this.state._topHeading, { mode: this.props.mode })}
                                </Typography>
                                <form
                                    className={classes.form}
                                    noValidate
                                    onSubmit={this.onSubmitHandler}
                                    style={{ maxWidth: '380px' }}
                                >
                                    <TextField
                                        autoComplete="otp"
                                        autoFocus
                                        className={classes.displayFlex}
                                        error={(!this.state._resetPasswordForm.otp.isValid) &&
                                                this.state._resetPasswordForm.otp.isTouched}
                                        fullWidth
                                        helperText={(!this.state._resetPasswordForm.otp.isValid) &&
                                                this.state._resetPasswordForm.otp.isTouched
                                            ? t(this.state._resetPasswordForm.otp.error_text) : ''}
                                        id="email"
                                        label={t(this.state._resetPasswordForm.otp.placeholder)}
                                        margin="normal"
                                        name="otp"
                                        onChange={this.handelInputChange}
                                        type="password"
                                        variant="outlined"
                                    />
                                    <TextField
                                        autoComplete="password"
                                        className={classes.displayFlex}
                                        error={(!this.state._resetPasswordForm.password.isValid) &&
                                                this.state._resetPasswordForm.password.isTouched}
                                        fullWidth
                                        helperText={(!this.state._resetPasswordForm.password.isValid) &&
                                                this.state._resetPasswordForm.password.isTouched
                                            ? t(this.state._resetPasswordForm.password.error_text) : ''}
                                        id="password"
                                        label={t(this.state._resetPasswordForm.password.placeholder)}
                                        margin="normal"
                                        name="password"
                                        onChange={this.handelInputChange}
                                        type="password"
                                        variant="outlined"
                                    />
                                    <TextField
                                        autoComplete="confirm_password"
                                        className={classes.displayFlex}
                                        error={(!this.state._resetPasswordForm.confirm_password.isValid) &&
                                                this.state._resetPasswordForm.confirm_password.isTouched}
                                        fullWidth
                                        helperText={(!this.state._resetPasswordForm.confirm_password.isValid) &&
                                                this.state._resetPasswordForm.confirm_password.isTouched
                                            ? t(this.state._resetPasswordForm.confirm_password.error_text) : ''}
                                        id="confirm_password"
                                        label={t(this.state._resetPasswordForm.confirm_password.placeholder)}
                                        margin="normal"
                                        name="confirm_password"
                                        onChange={this.handelInputChange}
                                        type="password"
                                        value={this.state._resetPasswordForm.confirm_password.value}
                                        variant="outlined"
                                    />
                                    <Error text={this.props.authError} />
                                    <div
                                        className={classes.blockdiv}
                                    >
                                        <Fab
                                            aria-label="add"
                                            className={classes.submit}
                                            color="primary"
                                            onClick={this.onSubmitHandler}
                                            size="medium"
                                            type="submit"
                                            variant="extended"
                                        >
                                            {t('buttons.submit')} &nbsp;
                                            {
                                                this.props.isLoading
                                                    ? <CircularProgress
                                                        disableShrink
                                                        size={18}
                                                    />
                                                    : <ArrowForwardIcon />

                                            }
                                        </Fab>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Grid>
                </Paper>
                <Alert
                    message={this.props.alert._message || ''}
                    onClose={this.props.hideAlert}
                    severity={this.props.alert._severity || 'success'}
                    show={this.props.alert._show || false}
                />
            </Container>
        );
    }
}

export default withStyles(commonStyle)(withTranslation()(index));
